import { useLabels } from "hooks";
import { t } from "i18next";
import React from "react";
import { ExtensionField, LookupField } from "types/payable";
import { getLabel } from "utilities/helper";
import { AmountField } from "./AmountField/AmountField";
import { BooleanField } from "./BooleanField";
import { DateField } from "./DateField";
import { DateTimeField } from "./DateTimeField/DateTimeField";
import { EmailAddress } from "./EmailAddress";
import { IntegerField } from "./IntegerField";
import { NonBlankText } from "./NonBlankText";
import { PhoneNumber } from "./PhoneNumber";
import { SelectManyField } from "./SelectManyField/SelectManyField";
import { SelectOne } from "./SelectOneField/SelectOneField";

export interface FieldProps {
  fieldDefinition: ExtensionField | LookupField;
}

export const Field = ({ fieldDefinition: fieldDef }: FieldProps) => {
  const { getLabels } = useLabels();
  const labelSource = getLabels();

  const commonProps: any = {
    name: fieldDef.name,
    label: getLabel(labelSource.labels, fieldDef.name),
  };

  if (fieldDef.placeholder) {
    commonProps.placeholder = getLabel(
      labelSource.labels,
      fieldDef.placeholder
    );
  }

  if ("editableIfPrefilled" in fieldDef) {
    commonProps.editableIfPrefilled = fieldDef.editableIfPrefilled;
  }

  return (
    <div key={fieldDef.name} className="ez-pay-payable-row">
      {fieldDef.type === "NonblankText" && <NonBlankText {...commonProps} />}
      {fieldDef.type === "Integer" && <IntegerField {...commonProps} />}
      {fieldDef.type === "Boolean" && (
        <BooleanField
          name={fieldDef.name}
          labelYes={`${t("radio-label-yes")}`}
          labelNo={`${t("radio-label-no")}`}
        />
      )}
      {fieldDef.type === "Email" && <EmailAddress {...commonProps} />}
      {fieldDef.type === "PhoneNumber" && <PhoneNumber {...commonProps} />}
      {fieldDef.type === "Date" && (
        <DateField {...commonProps} min={fieldDef.min} max={fieldDef.max} />
      )}
      {fieldDef.type === "DateTime" && (
        <DateTimeField {...commonProps} min={fieldDef.min} max={fieldDef.max} />
      )}
      {fieldDef.type === "DollarAmount" && <AmountField {...commonProps} />}
      {fieldDef.type === "SelectOne" && (
        <SelectOne {...commonProps} options={fieldDef.options} />
      )}
      {fieldDef.type === "SelectMany" && (
        <SelectManyField {...commonProps} options={fieldDef.options} />
      )}

      {/* {field.type === "Address" && <AddressField {...commonProps} />} */}
    </div>
  );
};
